import { Button, Checkbox, Col, Form, Input, Row } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import { useSelector } from "react-redux";
import s from "./assets/drawerProfile.module.css";

import CheckIcon from "../../assets/images/app/check.svg";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import TimeZoneList from "screens/teacher/components/TimeZoneList";

interface Props {
    isPhoneVerified: boolean;
    isEmailVerified: boolean;
    isUpdating: boolean;
    formInfos: any;
    updateUserInfos: (values: any) => void;
    setOpenPhoneModification: (values: any) => void;
}

const ParentOrganismUpdateProfile: FC<Props> = ({
    isPhoneVerified,
    isUpdating,
    formInfos,
    isEmailVerified,
    updateUserInfos,
    setOpenPhoneModification
}) => {
    //!HOOKS
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const [phone, setPhone] = useState<any>(user?.phone);
    const [isTyping, setIsTyping] = useState(false);

    const handlePhoneChange = (value: string, country: any) => {
        setIsTyping(true);
        const countryCode = country.countryCode as keyof typeof fr;
        const countryNameFr = fr[countryCode];
        setPhone(value);
        formInfos.setFieldsValue({ phone: value, pays: countryNameFr });
    };

    return (
        <Form form={formInfos} onFinish={updateUserInfos}>

            <Form.Item
                hasFeedback
                validateStatus={isEmailVerified ? "success" : "warning"}
                label={null}
                name="email"
                rules={[{ required: true, message: "Champ obligatoire" }]}
                style={{ margin: 0, padding: 0 }}
            >
                <Input
                    size="large"
                    className={s.field}
                    placeholder={t("auth.email")}
                    readOnly={true}
                />
            </Form.Item>

            <Form.Item
                hasFeedback
                validateStatus={isPhoneVerified ? "success" : "warning"}
                help={isPhoneVerified || isTyping ? null : t("auth.phoneNotVerified")}
                label={null}
                name="phone"
                rules={[{ required: false, message: "Champ obligatoire" }]}
                style={{
                    margin: 0,
                    padding: 0,
                    marginBottom: "15px",
                }}
            >
                <PhoneInput
                    country="fr"
                    disableCountryCode={false}
                    disableDropdown={false}
                    enableSearch
                    specialLabel=""
                    value={phone}
                    onChange={handlePhoneChange}
                    onClick={() => setOpenPhoneModification(true)}
                    inputProps={{
                        name: "phone",
                        required: true,
                        readOnly: true,
                        autoFocus: true,
                        className: `ant-input ant-input-lg ${s.field}`,
                        style: {
                            paddingLeft: "50px",
                        },
                    }}
                    localization={fr}
                />

                {isPhoneVerified ? (
                    <img
                        src={CheckIcon}
                        height={13}
                        style={{ color: "green", position: "absolute", right: 10, top: 12 }}
                    />
                ) : (
                    <ExclamationCircleOutlined
                        style={{ color: "#faad14", position: "absolute", right: 10, top: 12 }}
                    />
                )}
            </Form.Item>

            <Form.Item
                hasFeedback
                validateStatus={!!user?.firstname ? "success" : "warning"}
                help={!!user?.firstname ? "" : "Prénom non validé"}
                label={null}
                name="firstname"
                rules={[{ required: true, message: "Champ obligatoire" }]}
                style={{ margin: 0, padding: 0 }}
            >
                <Input
                    className={s.field}
                    size="large"
                    placeholder={t("auth.firstname")}
                />
            </Form.Item>

            <Form.Item
                hasFeedback
                validateStatus={!!user?.lastname ? "success" : "warning"}
                help={!!user?.lastname ? "" : "Nom non validé"}
                name="lastname"
                rules={[{ required: true, message: "Champ obligatoire" }]}
                style={{ margin: 0, padding: 0 }}
            >
                <Input
                    size="large"
                    className={s.field}
                    bordered={false}
                    placeholder={t("auth.lastname")}
                />
            </Form.Item>

            <TimeZoneList formInfos={user?.fuseauHorraire} />

            {user?.roles.includes("parent") && <div className={s.termes__legals}>
                <Form.Item
                    name="whatsappEnabled"
                    valuePropName="checked"
                    style={{ marginBottom: "20px" }}
                >
                    <Checkbox
                        style={{ color: "#636363" }}
                        className={s.policy}
                        onChange={(e) => formInfos.setFieldsValue({ whatsappEnabled: e.target.checked })}
                    >
                        {" "}
                        Autoriser les notifications whatsapp
                    </Checkbox>
                </Form.Item>
            </div>}

            <Form.Item style={{ margin: 0, padding: 0 }}>
                <Row gutter={20} justify="center">
                    <Col span={12}>
                        <Button
                            loading={isUpdating}
                            htmlType="submit"
                            block
                            type="primary"
                            size="large"
                            className={s.button}
                        >
                            Mettre à jour
                        </Button>
                    </Col>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default ParentOrganismUpdateProfile;
